import React from 'react';
import { Lock, LogOut } from 'lucide-react';

const fmtDateTime = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('vi-VN', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return String(iso);
  }
};

/**
 * Màn khi tài khoản bị khóa trực tiếp. Đơn giản: icon + tiêu đề + lý do + 1 dòng hướng dẫn.
 */
const AccountLockedScreen = ({ detail, onBack }) => {
  const reason = detail?.lockReason || 'Tài khoản của bạn đang bị khóa.';
  const lockedAt = detail?.lockedAt;

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-orange-50 to-yellow-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="bg-gradient-to-r from-red-600 to-red-700 px-6 py-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-4">
            <Lock className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">Tài khoản đã bị khóa</h1>
        </div>

        <div className="p-6 space-y-4">
          <div className="bg-red-50 border-l-4 border-red-500 p-3 rounded">
            <div className="text-xs font-semibold text-red-700 mb-1">LÝ DO</div>
            <div className="text-sm text-gray-800 whitespace-pre-wrap">{reason}</div>
            {lockedAt && (
              <div className="text-xs text-gray-500 mt-2">Khóa từ: {fmtDateTime(lockedAt)}</div>
            )}
          </div>

          <div className="text-sm text-gray-700 text-center">
            Vui lòng liên hệ <strong>quản trị</strong> để được mở khóa.
          </div>

          <button
            onClick={onBack}
            className="w-full flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-2.5 px-4 rounded-lg transition"
          >
            <LogOut className="w-4 h-4" />
            Quay lại đăng nhập
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountLockedScreen;
